// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__s1YAT","delete":"styles_delete__YDOC0","update":"styles_update__2iCCM","add":"styles_add__zl3q7"};